import React from 'react';
import Icon from '../Icons/Icon';
import $ from 'jQuery';

import ProductBrowseActions from './ProductBrowseActions';
import ProductBrowseStore from './ProductBrowseStore';
import CartStore from '../Cart/CartStore';
export default class SearchField extends React.Component {
	constructor(props) {
		super(props);

		this.state = ProductBrowseStore.getState();
		this.cart = CartStore.getState();
	}
	
	componentWillMount() {
		this.setState({
			resources: this.props.resources
		});
	}
	
	componentDidMount(){
		ProductBrowseStore.listen(this.onChange.bind(this));
	}
	
	componentWillUnmount(){
		ProductBrowseStore.unlisten(this.onChange.bind(this));
	}
	
	onChange(state) {
		this.setState(state);
	}
	
	searchKeyPress(e){
		if(e.which === 13) {
			this.submitSearch();
		}
	}

	submitSearch() {
		if (this.state.SearchField.trim().length > 0) {
			let terms = this.state.SearchTerms;
			terms.push(this.state.SearchField);
			let sendData = {
				categoryID: this.state.currentCategoryID,
				currency: this.cart.primaryCurrency,
				page: 1,
				searchTerm: terms,
				resultCount: this.state.resultCount
			};
			ProductBrowseActions.getNewProducts(sendData);
			if ($("#products-area"))
				this.setURL(terms);
		}
	}

	//Replace the current History Record with the new values
	setURL(terms){
		window.location.replace(`${window.jenkon.consultantRoot}Products#${encodeURIComponent(terms.join(','))}|${this.state.currentCategoryID}|1`);
	}
	
	handleChange() {
		this.setState({
			SearchField: this.refs.SearchField.value
		});
	}
	
	render(){
		let SearchIconData = {
			Size: 21,
			Fill: '#666666',
			name: 'Search'
		} 
		return(
			<div id="search" className="navSearch-container clearfix">
				<label htmlFor="searchField" className="visuallyhidden">{this.state.resources["PWS.AppNav.SearchFieldTitle"]}</label>
				<Icon iconData={SearchIconData} inline={true} onClick={this.submitSearch.bind(this)} />
				<input type="search" name="searchField" ref="SearchField" placeholder={this.state.resources["PWS.AppNav.SearchFieldLabel"]} onChange={this.handleChange.bind(this)} value={this.state.SearchField} onKeyPress={this.searchKeyPress.bind(this)} onBlur={this.submitSearch.bind(this)} />
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductBrowse/SearchField.js